import script from "./TonDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./TonDetails.vue?vue&type=script&setup=true&lang=js"

import "./TonDetails.vue?vue&type=style&index=0&id=1ddc4b06&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ddc4b06"]])

export default __exports__